
  import { format, addDays } from 'date-fns'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'CalendarDays',
    props: {
      startDate: {
        type: Date,
        required: true,
      },
      localeOptions: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      const days = []
      for (let i = 0; i < 7; i++) {
        days.push(addDays(props.startDate, i))
      }
      return { days, addDays, format }
    },
  })
